import { COLORS } from "@/themes/types"
import { resolveColor } from "@/themes/utils"
import { Typography, TypographyProps } from "@mui/material"
import { CSSProperties } from "react"

export type BbTextProps = Pick<
    TypographyProps,
    "variant" | "children" | "noWrap" | "fontWeight" | "fontFamily" | "fontSize" | "onMouseOver" | "onMouseLeave" | "lineHeight" | "component" | "sx"
> & {
    color?: "inherit" | COLORS
    /**
     * If set, use the contract color agains the color property
     * @default false
     */
    useContrastColor?: boolean
    lines?: number
    textDecoration?: "line-through" | "underline"
    prefix?: React.ReactNode
    prefixProps?: BbTextProps
    sufix?: React.ReactNode
    block?: boolean
    textTransform?: CSSProperties["textTransform"] | "firstLetterUppercase"
}

const BbText: React.FC<BbTextProps> = ({
    variant = "body1",
    color,
    useContrastColor,
    children,
    lines,
    textDecoration,
    prefix,
    prefixProps,
    sufix,
    block,
    textTransform,
    component = "span",
    sx,
    ...rest
}) => {
    return (
        <Typography
            {...rest}
            variant={variant}
            color={color}
            component={component}
            textTransform={textTransform === "firstLetterUppercase" ? "lowercase" : textTransform}
            sx={{
                color: (theme) => resolveColor(theme, color || "inherit", undefined, useContrastColor),
                WebkitLineClamp: lines?.toString(),
                WebkitBoxOrient: lines ? "vertical" : undefined,
                wordBreak: lines ? "break-word" : undefined,
                display: lines ? "-webkit-box" : block ? "block" : undefined,
                whiteSpace: lines ? "normal" : rest.noWrap ? "nowrap" : "pre-wrap",
                textDecoration,
                "&:first-letter": {
                    textTransform: textTransform === "firstLetterUppercase" ? "uppercase" : undefined,
                },
                ...sx,
            }}
        >
            {prefix && (
                <BbText {...rest} {...prefixProps} variant={variant} fontWeight="normal" component="span">
                    {prefix}:&nbsp;
                </BbText>
            )}
            {children}
            {sufix && (
                <Typography {...rest} variant={variant} fontWeight="normal" component="span" sx={{ color: (theme) => theme.palette.text.primary }}>
                    {sufix}
                </Typography>
            )}
        </Typography>
    )
}
export default BbText
